import React from "react";
import List from "@mui/material/List";
import ListSubheader from "@mui/material/ListSubheader";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import FolderIcon from "@mui/icons-material/Folder";
import Collapse from "@mui/material/Collapse";
import { NestedListItem } from "./NestedListItem";
import { UnnestedListItem } from "./UnnestedListItem";
import { handleUnnestedLevelClick } from "./SitesPageUtils/handleUnnestedLevelClick";
import { getIndividualGroup } from "./SitesPageUtils/getIndividualGroup";
import { AddGroupOrSiteDropDownMenu } from "./AddGroupOrSiteDropDownMenu";
import ListItemText from "@mui/material/ListItemText";
import { CircularProgress, Tooltip } from "@mui/material";
import { handlePushGroupsWithChildrenToTop } from "./SitesPageUtils/handlePushGroupsWithChildrenToTop";
import { GroupSearchBar } from "./GroupsSearchBar";
import { CameraIcon } from "../../../common/CameraIcon";
import { useSitesPageStore } from "./sitesPageStore/sitesPageStore";

export const SitesGroupList = ({
  groupTrees,
  selectedIndex,
  setPage,
  setCurrentTitle,
  setSelectedIndex,
  setRenderedRows,
  setPageLoading,
  navigate,
  setSiteBreadcrumbs,
  setAddGroupDialogOpen,
  permissions,
  navBarCollapsed,
  setSelected,
  searchBarValue,
  editedparentsGroupsList,
  setSearchBarValue,
  setEditedParentGroupList,
  setBackdropLoadingScreenOn,
  setSelectedGroupListName,
  setEditableGroupSelected,
}: {
  groupTrees: any;
  selectedIndex: any;
  setPage: any;
  setCurrentTitle: any;
  setSelectedIndex: any;
  setRenderedRows: any;
  setPageLoading: any;
  navigate: any;
  setSiteBreadcrumbs: any;
  setAddGroupDialogOpen: any;
  permissions: any;
  navBarCollapsed: boolean;
  setSelected: any;
  searchBarValue: any;
  editedparentsGroupsList: any;
  setSearchBarValue: any;
  setEditedParentGroupList: any;
  setBackdropLoadingScreenOn: any;
  setSelectedGroupListName: any;
  setEditableGroupSelected: any;
}) => {
  const { setSearchGroupId } = useSitesPageStore();

  React.useEffect(() => {
    if (localStorage.level1Click === "true") {
      localStorage.setItem("getIndividualGroupId", localStorage.level1Id);
      setSearchGroupId(Number(localStorage.level1Id));
      getIndividualGroup(
        Number(localStorage.level1Id),
        setRenderedRows,
        setPageLoading,
        setSiteBreadcrumbs,
        setSelected,
        setEditableGroupSelected,
        setSelectedGroupListName,
        navigate
      );
      setSelectedIndex((previousState: any) => {
        return { ...previousState, level1: [Number(localStorage.level1Id)] };
      });
      localStorage.removeItem("level2Id");
      localStorage.removeItem("level3Id");
      localStorage.removeItem("level4Id");
      localStorage.removeItem("level5Id");
      localStorage.setItem("level1Click", "false");
    } else if (localStorage.level2Click === "true") {
      localStorage.setItem("getIndividualGroupId", localStorage.level2Id);
      setSearchGroupId(Number(localStorage.level2Id));
      getIndividualGroup(
        Number(localStorage.level2Id),
        setRenderedRows,
        setPageLoading,
        setSiteBreadcrumbs,
        setSelected,
        setEditableGroupSelected,
        setSelectedGroupListName,
        navigate
      );
      window.location.pathname.includes("patrol")
        ? setSelectedIndex((previousState: any) => {
            return {
              ...previousState,
              level1: [Number(localStorage.level2Id)],
              level2: [],
            };
          })
        : setSelectedIndex((previousState: any) => {
            return {
              ...previousState,
              level1: [Number(localStorage.level1Id)],
              level2: [Number(localStorage.level2Id)],
            };
          });

      localStorage.removeItem("level3Id");
      localStorage.removeItem("level4Id");
      localStorage.removeItem("level5Id");
      localStorage.setItem("level2Click", "false");
    } else if (localStorage.level3Click === "true") {
      localStorage.setItem("getIndividualGroupId", localStorage.level3Id);
      setSearchGroupId(Number(localStorage.level3Id));
      getIndividualGroup(
        Number(localStorage.level3Id),
        setRenderedRows,
        setPageLoading,
        setSiteBreadcrumbs,
        setSelected,
        setEditableGroupSelected,
        setSelectedGroupListName,
        navigate
      );
      setSelectedIndex((previousState: any) => {
        return {
          ...previousState,
          level1: [Number(localStorage.level1Id)],
          level2: [Number(localStorage.level2Id)],
          level3: [Number(localStorage.level3Id)],
        };
      });
      localStorage.removeItem("level4Id");
      localStorage.removeItem("level5Id");
      localStorage.setItem("level3Click", "false");
    } else if (localStorage.level4Click === "true") {
      localStorage.setItem("getIndividualGroupId", localStorage.level4Id);
      setSearchGroupId(Number(localStorage.level4Id));
      getIndividualGroup(
        Number(localStorage.level4Id),
        setRenderedRows,
        setPageLoading,
        setSiteBreadcrumbs,
        setSelected,
        setEditableGroupSelected,
        setSelectedGroupListName,
        navigate
      );
      setSelectedIndex((previousState: any) => {
        return {
          ...previousState,
          level1: [Number(localStorage.level1Id)],
          level2: [Number(localStorage.level2Id)],
          level3: [Number(localStorage.level3Id)],
          level4: [Number(localStorage.level4Id)],
        };
      });
      localStorage.removeItem("level5Id");
      localStorage.setItem("level4Click", "false");
    } else if (localStorage.level5Click === "true") {
      localStorage.setItem("getIndividualGroupId", localStorage.level5Id);
      setSearchGroupId(Number(localStorage.level5Id));
      getIndividualGroup(
        Number(localStorage.level5Id),
        setRenderedRows,
        setPageLoading,
        setSiteBreadcrumbs,
        setSelected,
        setEditableGroupSelected,
        setSelectedGroupListName,
        navigate
      );
      setSelectedIndex((previousState: any) => {
        return {
          ...previousState,
          level1: [Number(localStorage.level1Id)],
          level2: [Number(localStorage.level2Id)],
          level3: [Number(localStorage.level3Id)],
          level4: [Number(localStorage.level4Id)],
          level5: [Number(localStorage.level5Id)],
        };
      });
      localStorage.setItem("level5Click", "false");
    }
  }, []);

  const {
    getSelectedGroupCounts,
    selectedGroupCounts,
    fetchingSelectedGroupCounts,
  } = useSitesPageStore();

  return (
    <div>
      <List
        sx={{ width: "100%", maxWidth: 360, bgcolor: "background.paper" }}
        component="nav"
        aria-labelledby="nested-list-subheader"
        subheader={
          <ListSubheader
            sx={{ fontSize: "18px", fontFamily: "Mulish" }}
            component="div"
            id="all-parent-group-subheader"
          >
            {searchBarValue
              ? `Filtered Groups (${editedparentsGroupsList.length})`
              : "Parent Groups & Sites"}
            {/* Always shown: the menu gates its own items. "Download
                Sites Overview" is available to every level, including
                View Only, so the menu cannot hinge on add_cameras. */}
            <div className="relative left-[185px] top-[-48px] h-[1px]">
              <AddGroupOrSiteDropDownMenu
                navigate={navigate}
                setAddGroupDialogOpen={setAddGroupDialogOpen}
              />
            </div>

            {/* {!window.location.pathname.includes("patrol") && ( */}
            <div className="relative left-[-40px]">
              <GroupSearchBar
                setSearchBarValue={setSearchBarValue}
                setEditedParentGroupList={setEditedParentGroupList}
                setBackdropLoadingScreenOn={setBackdropLoadingScreenOn}
                searchBarValue={searchBarValue}
              />
            </div>
            {/* )} */}
          </ListSubheader>
        }
      >
        {groupTrees === undefined ? (
          <div className="relative left-[55px] top-[15px]">
            <CircularProgress
              size={25}
              sx={{ position: "relative", left: 45 }}
            />
            <div className="font-mulish text-bold">Fetching groups...</div>
          </div>
        ) : searchBarValue ? (
          <>
            {editedparentsGroupsList.length === 0 && (
              <div className="font-mulish text-sm text-gray-500 pl-4 pt-2">
                {`No sites found for "${searchBarValue}"`}
              </div>
            )}
            {editedparentsGroupsList.map((arrayLvl1Item: any) => {
              {
                if (arrayLvl1Item.parent_account) {
                  return (
                    <Tooltip
                      key={arrayLvl1Item.id}
                      title={
                        <div>
                          {fetchingSelectedGroupCounts &&
                            (!selectedGroupCounts ||
                              selectedGroupCounts.id !== arrayLvl1Item.id) && (
                              <div>Loading counts...</div>
                            )}
                          {selectedGroupCounts &&
                            selectedGroupCounts.id === arrayLvl1Item.id && (
                              <>
                                <div>{arrayLvl1Item.name}</div>
                                {selectedGroupCounts.sub_groups !==
                                  undefined && (
                                  <div>{`Sub Groups: ${selectedGroupCounts.sub_groups}`}</div>
                                )}
                                {selectedGroupCounts.sites !== undefined && (
                                  <div>{`Sites: ${selectedGroupCounts.sites}`}</div>
                                )}
                              </>
                            )}
                        </div>
                      }
                      placement="right"
                      onOpen={() => {
                        getSelectedGroupCounts(navigate, arrayLvl1Item.id);
                      }}
                    >
                      <ListItemButton
                        onClick={() => {
                          handleUnnestedLevelClick(
                            setPage,
                            setCurrentTitle,
                            arrayLvl1Item.name,
                            arrayLvl1Item.id,
                            setRenderedRows,
                            setPageLoading,
                            navigate,
                            setSiteBreadcrumbs,
                            setSelected,
                            false,
                            setSelectedGroupListName,
                            setEditableGroupSelected
                          );
                        }}
                      >
                        <ListItemIcon>
                          <FolderIcon />
                        </ListItemIcon>
                        <ListItemText
                          primary={arrayLvl1Item.name}
                          primaryTypographyProps={{
                            fontSize: 14,
                            fontFamily: "Mulish",
                          }}
                        />
                      </ListItemButton>
                    </Tooltip>
                  );
                } else {
                  return (
                    <ListItemButton
                      key={arrayLvl1Item.id}
                      onClick={() => {
                        handleUnnestedLevelClick(
                          setPage,
                          setCurrentTitle,
                          arrayLvl1Item.name,
                          arrayLvl1Item.id,
                          setRenderedRows,
                          setPageLoading,
                          navigate,
                          setSiteBreadcrumbs,
                          setSelected,
                          true,
                          setSelectedGroupListName,
                          setEditableGroupSelected
                        );
                      }}
                    >
                      <div className="relative left-[-15px]">
                        <ListItemIcon>
                          <CameraIcon />
                        </ListItemIcon>
                      </div>
                      <div className="relative">
                        <ListItemText
                          primary={arrayLvl1Item.name}
                          primaryTypographyProps={{
                            fontSize: 14,
                            fontFamily: "Mulish",
                          }}
                        />
                      </div>
                    </ListItemButton>
                  );
                }
              }
            })}
          </>
        ) : (
          <>
            {handlePushGroupsWithChildrenToTop(groupTrees).map(
              (arrayLvl1Item: any) => {
                if (arrayLvl1Item.children[0]) {
                  return (
                    <div key={arrayLvl1Item.id}>
                      <NestedListItem
                        arrayItem={arrayLvl1Item}
                        selectedIndex={selectedIndex}
                        setPage={setPage}
                        setCurrentTitle={setCurrentTitle}
                        levelName={"level1"}
                        setSelectedIndex={setSelectedIndex}
                        setRenderedRows={setRenderedRows}
                        setPageLoading={setPageLoading}
                        navigate={navigate}
                        indentNumber={undefined}
                        setSiteBreadcrumbs={setSiteBreadcrumbs}
                        navBarCollapsed={navBarCollapsed}
                        setSelected={setSelected}
                        setSelectedGroupListName={setSelectedGroupListName}
                        setEditableGroupSelected={setEditableGroupSelected}
                      />
                      <Collapse
                        in={selectedIndex.level1.includes(arrayLvl1Item.id)}
                        timeout="auto"
                        unmountOnExit
                      >
                        {handlePushGroupsWithChildrenToTop(
                          arrayLvl1Item.children
                        ).map((arrayLvl2Item: any) => {
                          if (arrayLvl2Item.children[0]) {
                            return (
                              <div key={arrayLvl2Item.id}>
                                <NestedListItem
                                  arrayItem={arrayLvl2Item}
                                  selectedIndex={selectedIndex}
                                  setPage={setPage}
                                  setCurrentTitle={setCurrentTitle}
                                  levelName={"level2"}
                                  setSelectedIndex={setSelectedIndex}
                                  setRenderedRows={setRenderedRows}
                                  setPageLoading={setPageLoading}
                                  navigate={navigate}
                                  indentNumber={5}
                                  setSiteBreadcrumbs={setSiteBreadcrumbs}
                                  navBarCollapsed={navBarCollapsed}
                                  setSelected={setSelected}
                                  setSelectedGroupListName={
                                    setSelectedGroupListName
                                  }
                                  setEditableGroupSelected={
                                    setEditableGroupSelected
                                  }
                                />
                                <Collapse
                                  in={
                                    // arrayLvl2Item.id === selectedIndex.level2
                                    selectedIndex.level2.includes(
                                      arrayLvl2Item.id
                                    )
                                  }
                                  timeout="auto"
                                  unmountOnExit
                                >
                                  {handlePushGroupsWithChildrenToTop(
                                    arrayLvl2Item.children
                                  ).map((arrayLvl3Item: any) => {
                                    if (arrayLvl3Item.children[0]) {
                                      return (
                                        <div key={arrayLvl3Item.id}>
                                          <NestedListItem
                                            arrayItem={arrayLvl3Item}
                                            selectedIndex={selectedIndex}
                                            setPage={setPage}
                                            setCurrentTitle={setCurrentTitle}
                                            levelName={"level3"}
                                            setSelectedIndex={setSelectedIndex}
                                            setRenderedRows={setRenderedRows}
                                            setPageLoading={setPageLoading}
                                            navigate={navigate}
                                            indentNumber={8}
                                            setSiteBreadcrumbs={
                                              setSiteBreadcrumbs
                                            }
                                            navBarCollapsed={navBarCollapsed}
                                            setSelected={setSelected}
                                            setSelectedGroupListName={
                                              setSelectedGroupListName
                                            }
                                            setEditableGroupSelected={
                                              setEditableGroupSelected
                                            }
                                          />
                                          <Collapse
                                            in={selectedIndex.level3.includes(
                                              arrayLvl3Item.id
                                            )}
                                            timeout="auto"
                                            unmountOnExit
                                          >
                                            {handlePushGroupsWithChildrenToTop(
                                              arrayLvl3Item.children
                                            ).map((arrayLvl4Item: any) => {
                                              if (arrayLvl4Item.children[0]) {
                                                return (
                                                  <div key={arrayLvl4Item.id}>
                                                    <NestedListItem
                                                      arrayItem={arrayLvl4Item}
                                                      selectedIndex={
                                                        selectedIndex
                                                      }
                                                      setPage={setPage}
                                                      setCurrentTitle={
                                                        setCurrentTitle
                                                      }
                                                      levelName={"level4"}
                                                      setSelectedIndex={
                                                        setSelectedIndex
                                                      }
                                                      setRenderedRows={
                                                        setRenderedRows
                                                      }
                                                      setPageLoading={
                                                        setPageLoading
                                                      }
                                                      navigate={navigate}
                                                      indentNumber={11}
                                                      setSiteBreadcrumbs={
                                                        setSiteBreadcrumbs
                                                      }
                                                      navBarCollapsed={
                                                        navBarCollapsed
                                                      }
                                                      setSelected={setSelected}
                                                      setSelectedGroupListName={
                                                        setSelectedGroupListName
                                                      }
                                                      setEditableGroupSelected={
                                                        setEditableGroupSelected
                                                      }
                                                    />
                                                    <Collapse
                                                      in={selectedIndex.level4.includes(
                                                        arrayLvl4Item.id
                                                      )}
                                                      timeout="auto"
                                                      unmountOnExit
                                                    >
                                                      {handlePushGroupsWithChildrenToTop(
                                                        arrayLvl4Item.children
                                                      ).map(
                                                        (
                                                          arrayLvl5Item: any
                                                        ) => {
                                                          if (
                                                            arrayLvl5Item
                                                              .children[0]
                                                          ) {
                                                            return (
                                                              <div
                                                                key={
                                                                  arrayLvl5Item.id
                                                                }
                                                              >
                                                                <NestedListItem
                                                                  arrayItem={
                                                                    arrayLvl5Item
                                                                  }
                                                                  selectedIndex={
                                                                    selectedIndex
                                                                  }
                                                                  setPage={
                                                                    setPage
                                                                  }
                                                                  setCurrentTitle={
                                                                    setCurrentTitle
                                                                  }
                                                                  levelName={
                                                                    "level5"
                                                                  }
                                                                  setSelectedIndex={
                                                                    setSelectedIndex
                                                                  }
                                                                  setRenderedRows={
                                                                    setRenderedRows
                                                                  }
                                                                  setPageLoading={
                                                                    setPageLoading
                                                                  }
                                                                  navigate={
                                                                    navigate
                                                                  }
                                                                  indentNumber={
                                                                    14
                                                                  }
                                                                  setSiteBreadcrumbs={
                                                                    setSiteBreadcrumbs
                                                                  }
                                                                  navBarCollapsed={
                                                                    navBarCollapsed
                                                                  }
                                                                  setSelected={
                                                                    setSelected
                                                                  }
                                                                  setSelectedGroupListName={
                                                                    setSelectedGroupListName
                                                                  }
                                                                  setEditableGroupSelected={
                                                                    setEditableGroupSelected
                                                                  }
                                                                />
                                                                <Collapse
                                                                  in={selectedIndex.level5.includes(
                                                                    arrayLvl5Item.id
                                                                  )}
                                                                  timeout="auto"
                                                                  unmountOnExit
                                                                >
                                                                  {handlePushGroupsWithChildrenToTop(
                                                                    arrayLvl5Item.children
                                                                  ).map(
                                                                    (
                                                                      arrayLvl6Item: any
                                                                    ) => {
                                                                      if (
                                                                        arrayLvl6Item
                                                                          .children[0]
                                                                      ) {
                                                                        return (
                                                                          <div
                                                                            key={
                                                                              arrayLvl6Item.id
                                                                            }
                                                                          >
                                                                            <NestedListItem
                                                                              arrayItem={
                                                                                arrayLvl6Item
                                                                              }
                                                                              selectedIndex={
                                                                                selectedIndex
                                                                              }
                                                                              setPage={
                                                                                setPage
                                                                              }
                                                                              setCurrentTitle={
                                                                                setCurrentTitle
                                                                              }
                                                                              levelName={
                                                                                "level6"
                                                                              }
                                                                              setSelectedIndex={
                                                                                setSelectedIndex
                                                                              }
                                                                              setRenderedRows={
                                                                                setRenderedRows
                                                                              }
                                                                              setPageLoading={
                                                                                setPageLoading
                                                                              }
                                                                              navigate={
                                                                                navigate
                                                                              }
                                                                              indentNumber={
                                                                                17
                                                                              }
                                                                              setSiteBreadcrumbs={
                                                                                setSiteBreadcrumbs
                                                                              }
                                                                              navBarCollapsed={
                                                                                navBarCollapsed
                                                                              }
                                                                              setSelected={
                                                                                setSelected
                                                                              }
                                                                              setSelectedGroupListName={
                                                                                setSelectedGroupListName
                                                                              }
                                                                              setEditableGroupSelected={
                                                                                setEditableGroupSelected
                                                                              }
                                                                            />
                                                                          </div>
                                                                        );
                                                                      } else {
                                                                        return (
                                                                          <List
                                                                            component="div"
                                                                            key={
                                                                              arrayLvl6Item.id
                                                                            }
                                                                          >
                                                                            <UnnestedListItem
                                                                              arrayItem={
                                                                                arrayLvl6Item
                                                                              }
                                                                              setPage={
                                                                                setPage
                                                                              }
                                                                              setCurrentTitle={
                                                                                setCurrentTitle
                                                                              }
                                                                              indentNumber={
                                                                                12
                                                                              }
                                                                              setRenderedRows={
                                                                                setRenderedRows
                                                                              }
                                                                              setPageLoading={
                                                                                setPageLoading
                                                                              }
                                                                              navigate={
                                                                                navigate
                                                                              }
                                                                              setSiteBreadcrumbs={
                                                                                setSiteBreadcrumbs
                                                                              }
                                                                              navBarCollapsed={
                                                                                navBarCollapsed
                                                                              }
                                                                              setSelected={
                                                                                setSelected
                                                                              }
                                                                              setSelectedGroupListName={
                                                                                setSelectedGroupListName
                                                                              }
                                                                              setEditableGroupSelected={
                                                                                setEditableGroupSelected
                                                                              }
                                                                            />
                                                                          </List>
                                                                        );
                                                                      }
                                                                    }
                                                                  )}
                                                                </Collapse>
                                                              </div>
                                                            );
                                                          } else {
                                                            return (
                                                              <List
                                                                component="div"
                                                                key={
                                                                  arrayLvl5Item.id
                                                                }
                                                              >
                                                                <UnnestedListItem
                                                                  arrayItem={
                                                                    arrayLvl5Item
                                                                  }
                                                                  setPage={
                                                                    setPage
                                                                  }
                                                                  setCurrentTitle={
                                                                    setCurrentTitle
                                                                  }
                                                                  indentNumber={
                                                                    12
                                                                  }
                                                                  setRenderedRows={
                                                                    setRenderedRows
                                                                  }
                                                                  setPageLoading={
                                                                    setPageLoading
                                                                  }
                                                                  navigate={
                                                                    navigate
                                                                  }
                                                                  setSiteBreadcrumbs={
                                                                    setSiteBreadcrumbs
                                                                  }
                                                                  navBarCollapsed={
                                                                    navBarCollapsed
                                                                  }
                                                                  setSelected={
                                                                    setSelected
                                                                  }
                                                                  setSelectedGroupListName={
                                                                    setSelectedGroupListName
                                                                  }
                                                                  setEditableGroupSelected={
                                                                    setEditableGroupSelected
                                                                  }
                                                                />
                                                              </List>
                                                            );
                                                          }
                                                        }
                                                      )}
                                                    </Collapse>
                                                  </div>
                                                );
                                              } else {
                                                return (
                                                  <List
                                                    component="div"
                                                    key={arrayLvl4Item.id}
                                                  >
                                                    <UnnestedListItem
                                                      arrayItem={arrayLvl4Item}
                                                      setPage={setPage}
                                                      setCurrentTitle={
                                                        setCurrentTitle
                                                      }
                                                      indentNumber={9}
                                                      setRenderedRows={
                                                        setRenderedRows
                                                      }
                                                      setPageLoading={
                                                        setPageLoading
                                                      }
                                                      navigate={navigate}
                                                      setSiteBreadcrumbs={
                                                        setSiteBreadcrumbs
                                                      }
                                                      navBarCollapsed={
                                                        navBarCollapsed
                                                      }
                                                      setSelected={setSelected}
                                                      setSelectedGroupListName={
                                                        setSelectedGroupListName
                                                      }
                                                      setEditableGroupSelected={
                                                        setEditableGroupSelected
                                                      }
                                                    />
                                                  </List>
                                                );
                                              }
                                            })}
                                          </Collapse>
                                        </div>
                                      );
                                    } else {
                                      return (
                                        <List
                                          component="div"
                                          key={arrayLvl3Item.id}
                                        >
                                          <UnnestedListItem
                                            arrayItem={arrayLvl3Item}
                                            setPage={setPage}
                                            setCurrentTitle={setCurrentTitle}
                                            indentNumber={6}
                                            setRenderedRows={setRenderedRows}
                                            setPageLoading={setPageLoading}
                                            navigate={navigate}
                                            setSiteBreadcrumbs={
                                              setSiteBreadcrumbs
                                            }
                                            navBarCollapsed={navBarCollapsed}
                                            setSelected={setSelected}
                                            setSelectedGroupListName={
                                              setSelectedGroupListName
                                            }
                                            setEditableGroupSelected={
                                              setEditableGroupSelected
                                            }
                                          />
                                        </List>
                                      );
                                    }
                                  })}
                                </Collapse>
                              </div>
                            );
                          } else {
                            return (
                              <List component="div" key={arrayLvl2Item.id}>
                                <UnnestedListItem
                                  arrayItem={arrayLvl2Item}
                                  setPage={setPage}
                                  setCurrentTitle={setCurrentTitle}
                                  indentNumber={3}
                                  setRenderedRows={setRenderedRows}
                                  setPageLoading={setPageLoading}
                                  navigate={navigate}
                                  setSiteBreadcrumbs={setSiteBreadcrumbs}
                                  navBarCollapsed={navBarCollapsed}
                                  setSelected={setSelected}
                                  setSelectedGroupListName={
                                    setSelectedGroupListName
                                  }
                                  setEditableGroupSelected={
                                    setEditableGroupSelected
                                  }
                                />
                              </List>
                            );
                          }
                        })}
                      </Collapse>
                    </div>
                  );
                } else {
                  if (arrayLvl1Item.parent_account) {
                    return (
                      <Tooltip
                        key={arrayLvl1Item.id}
                        title={
                          fetchingSelectedGroupCounts ? (
                            <div>Loading counts...</div>
                          ) : selectedGroupCounts &&
                            selectedGroupCounts.id === arrayLvl1Item.id &&
                            selectedGroupCounts.sites !== undefined ? (
                            <div>
                              <div>{arrayLvl1Item.name}</div>
                              <div>{`Sub Groups: ${selectedGroupCounts.sub_groups}`}</div>
                              <div>{`Sites: ${selectedGroupCounts.sites}`}</div>
                            </div>
                          ) : null
                        }
                        placement="right"
                        onOpen={() => {
                          getSelectedGroupCounts(navigate, arrayLvl1Item.id);
                        }}
                      >
                        <ListItemButton
                          key={arrayLvl1Item.id}
                          onClick={() => {
                            handleUnnestedLevelClick(
                              setPage,
                              setCurrentTitle,
                              arrayLvl1Item.name,
                              arrayLvl1Item.id,
                              setRenderedRows,
                              setPageLoading,
                              navigate,
                              setSiteBreadcrumbs,
                              setSelected,
                              false,
                              setSelectedGroupListName,
                              setEditableGroupSelected
                            );
                          }}
                        >
                          <ListItemIcon>
                            <FolderIcon />
                          </ListItemIcon>
                          <ListItemText
                            primary={`${arrayLvl1Item.name}`}
                            primaryTypographyProps={{
                              fontSize: 14,
                              fontFamily: "Mulish",
                            }}
                          />
                        </ListItemButton>
                      </Tooltip>
                    );
                  } else {
                    return (
                      <List component="div" key={arrayLvl1Item.id}>
                        <UnnestedListItem
                          arrayItem={arrayLvl1Item}
                          setPage={setPage}
                          setCurrentTitle={setCurrentTitle}
                          indentNumber={0}
                          setRenderedRows={setRenderedRows}
                          setPageLoading={setPageLoading}
                          navigate={navigate}
                          setSiteBreadcrumbs={setSiteBreadcrumbs}
                          navBarCollapsed={navBarCollapsed}
                          setSelected={setSelected}
                          setSelectedGroupListName={setSelectedGroupListName}
                          setEditableGroupSelected={setEditableGroupSelected}
                        />
                      </List>
                    );
                  }
                }
              }
            )}
          </>
        )}
      </List>
    </div>
  );
};
